module.exports = __webpack_public_path__ + "assets/img/about.b83ac752.jpg";